module.exports = __webpack_public_path__ + "static/media/cwiczenie-pisania-na-klawiaturze-inf3-1.2d097c1d.png";